import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import { useAuth } from '../context/AuthContext';
import { newsletterApi } from '../services/api';
import { usePWA } from '../context/PWAContext';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [checkingStatus, setCheckingStatus] = useState(true);
  const { whatsappNumber } = useSettings();
  const { user } = useAuth();
  const { isInstallable, isInstalled, triggerInstall } = usePWA();

  useEffect(() => {
    const checkSubscription = async () => {
      if (user?.email) {
        setEmail(user.email);
        try {
          const status = await newsletterApi.checkStatus(user.email);
          setSubscribed(status.subscribed);
        } catch (err) {
          // Subscription check failed
        }
      }
      setCheckingStatus(false);
    };
    checkSubscription();
  }, [user]);

  // If user is logged in but checking status, show placeholder space
  if (user && checkingStatus) {
    return (
      <footer className="bg-primary text-white">
        <div className="max-w-7xl mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div></div><div></div><div></div>
            <div className="w-full max-w-xs">
              <h4 className="font-semibold mb-4">Newsletter</h4>
              <div className="animate-pulse h-10 bg-gray-700 rounded"></div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    setError('');

    try {
      await newsletterApi.subscribe({ email });
      setSubscribed(true);
      setEmail('');
    } catch (err) {
      setError(err.message || 'Failed to subscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <h3 className="text-xl font-bold text-gold mb-4">LUXE-LOOKS</h3>
            <p className="text-sm text-gray-300 mb-4">
              Your destination for premium beauty and cosmetics. Discover the finest brands and exclusive deals.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold transition-colors">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24"><path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.899-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/></svg>
              </a>
<a href={`https://wa.me/${whatsappNumber ? whatsappNumber.replace(/\s/g, '') : ''}`} target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <img 
                  src="https://img.icons8.com/color/48/whatsapp--v3.png" 
                  alt="WhatsApp" 
                  className="h-5 w-5"
                  loading="lazy" decoding="async"
                />
              </a>
              <a href="https://tiktok.com/@luxelooks" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                <svg className="h-5 w-5" viewBox="0 0 24 24">
                  <path fill="#ffffff" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.15z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
             <ul className="space-y-2 text-sm text-gray-300">
               <li><Link to="/about-us" className="hover:text-gold transition-colors">About Us</Link></li>
               <li><Link to="/careers" className="hover:text-gold transition-colors">Careers</Link></li>
               <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
              <li><Link to="/shipping-policy" className="hover:text-gold transition-colors">Shipping Policy</Link></li>
              <li><Link to="/returns-refunds" className="hover:text-gold transition-colors">Returns & Refunds</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-gold transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-gold transition-colors">Terms of Service</Link></li>
              <li><Link to="/disclaimers" className="hover:text-gold transition-colors">Disclaimers</Link></li>
              {isInstallable && !isInstalled && (
                <li>
                  <button
                    onClick={triggerInstall}
                    className="hover:text-gold transition-colors text-sm"
                  >
                    📲 Install App
                  </button>
                </li>
              )}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Customer Care</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li><Link to="/faqs" className="hover:text-gold transition-colors">FAQs</Link></li>
              <li><Link to="/track-order" className="hover:text-gold transition-colors">Track Order</Link></li>
              <li><Link to="/gift-card" className="hover:text-gold transition-colors">Gift Cards</Link></li>
            </ul>
          </div>

          <div className="w-full max-w-xs">
            <h4 className="font-semibold mb-4">Newsletter</h4>
            <p className="text-sm text-gray-300 mb-4">
              Subscribe to receive updates, access to exclusive deals, and more.
            </p>
            {subscribed ? (
              <div className="space-y-1">
                <span className="text-green-400 text-sm block">✓ Already subscribed</span>
                {user && <span className="text-gray-400 text-sm block">{user.email}</span>}
              </div>
            ) : (
              <>
                <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-2 w-full">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-3 py-2 bg-gray-800 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold rounded-md text-sm"
                    required
                    disabled={loading}
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full sm:w-auto px-4 py-2 bg-gold hover:brightness-90 text-white transition-colors rounded-md disabled:opacity-50 whitespace-nowrap"
                  >
                    {loading ? 'Subscribing...' : 'Subscribe'}
                  </button>
                </form>
                {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
              </>
            )}
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2026 Luxe-Looks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;